export const serviceURL = process.env.REACT_APP_BASE_URL.trim();